import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import StudentEnrollmentsTable from '../../components/studentEnrollments/StudentEnrollmentsTable';
const StudentEnrollments = () => (<WrapperSection><GlobalBreadcrumbs /><StudentEnrollmentsTable /></WrapperSection>);
export default StudentEnrollments;
